import { FaBrain, FaCode } from "react-icons/fa";
import { SiProgress } from "react-icons/si";
import { CgWebsite } from "react-icons/cg";
import { BsMicrosoftTeams } from "react-icons/bs";
import { MdWifiLock } from "react-icons/md";

// Features Data
export const featuresData = [
  {
    id: 1,
    icon: <CgWebsite />,
    title: "Web Development",
    des: "Experienced in web development and completed 25+ projects, showcasing a range of skills from front-end design to back-end development. Passionate about building responsive, user-friendly websites!",
  },
  {
    id: 2,
    icon: <BsMicrosoftTeams />,
    title: "Team Management",
    des: "Managed various projects, including leading a team in the Code Samurai Inter-University Hackathon 2024. Successfully handled a real-time full-stack project, demonstrating strong leadership and technical skills!",
  },
  {
    id: 3,
    icon: <FaCode />,
    title: "Competitive Programmer",
    des: "Competitive programmer with experience solving over 1,000+ easy and medium-level problems, demonstrating strong problem-solving skills and algorithmic thinking.",
  },
  {
    id: 4,
    icon: <MdWifiLock />,
    title: "Cyber Security",
    des: "Experienced in cybersecurity with a focus on DDoS detection techniques. Completed a thesis on innovative methods for detecting and mitigating DDoS attacks!",
  },
  {
    id: 5,
    icon: <SiProgress />,
    title: "SEO Optimisation",
    des: "Will learn this soon in near future !",
  },
  {
    id: 6,
    icon: <FaBrain />,
    title: "Machine Learning",
    des: "Will learn this soon in near future !",
  },
];
